import React, { useState } from 'react';
import ProductoCard from './ProductoCard';
import CompartirProductoModal from './CompartirProductoModal';
import { DIMENSIONES } from '../utils/agrupar';
import { exportarEtiquetasCSV } from '../utils/exportar';
import { useToast } from '../context/ToastContext';

export default function InventarioLista({ productos, categoriaSeleccionada, dimension, grupoSeleccionado, soloStockBajo, busqueda, onBuscar, cargando, error, onVolver, onVerProducto, onReintentar, onVerCategorias, onVerDetalle, onCompartirGrupo, stockBajo = 0, onVerStockBajo }) {
  const { mostrarToast } = useToast();
  const [compartir, setCompartir] = useState(null);
  const [soloOcultos, setSoloOcultos] = useState(false); // 🙈 los que no se ven en el catálogo
  const ocultos = productos.filter((p) => p.activo === false);
  const lista = soloOcultos ? ocultos : productos;

  const exportar = () => {
    if (productos.length === 0) { mostrarToast('No hay productos para exportar', 'error'); return; }
    exportarEtiquetasCSV(productos);
    mostrarToast(`Excel de ${productos.length} etiqueta(s) descargado 📄 Impórtalo en Print Master`, 'exito', 6000);
  };

  // La lectora de código de barras escribe el código y envía Enter:
  // si hay coincidencia exacta se abre el producto directo.
  // Normaliza un código para comparar: solo letras y números en mayúscula.
  // Así "CB-0001", "CB'0001" (el lector manda el guion como apóstrofo según
  // el teclado) o "cb 0001" se consideran el mismo código.
  const normCodigo = (s) => (s || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

  const manejarEnter = (e) => {
    if (e.key !== 'Enter') return;
    const codigo = normCodigo(e.target.value); // valor real del campo
    if (!codigo) return;
    const exacto = productos.find((p) => normCodigo(p.codigo) === codigo);
    if (exacto) {
      onVerProducto(exacto);
      onBuscar('');
    }
  };

  const info = DIMENSIONES[dimension] || DIMENSIONES.talla;
  const grupoTxt = grupoSeleccionado === '__sin__'
    ? info.sinLabel
    : grupoSeleccionado ? `${info.prefijoTarjeta}${grupoSeleccionado}` : '';
  const titulo = soloStockBajo
    ? '⚠️ Stock bajo'
    : [categoriaSeleccionada || 'Todo el Inventario', grupoTxt].filter(Boolean).join(' · ');

  return (
    <div className="k-page">
      <div className="k-page-head">
        <h2 className="k-page-title">
          📦 {soloOcultos ? '🙈 Ocultos del catálogo' : titulo} — {lista.length} productos
        </h2>
        <div className="k-actions">
          {onCompartirGrupo && (
            <button onClick={onCompartirGrupo}
              style={{ backgroundColor: '#25D366', border: 'none', borderRadius: '8px', padding: '6px 12px', cursor: 'pointer', color: 'white', fontWeight: 'bold' }}>
              💬 Compartir esta {info.etiqueta.toLowerCase()}
            </button>
          )}
          {!cargando && !error && productos.length > 0 && (
            <button onClick={exportar} title="Descarga un Excel/CSV para imprimir las etiquetas en lote desde Print Master" className="k-btn-ghost">
              🏷️ Exportar etiquetas
            </button>
          )}
          {onVerStockBajo && (
            <button onClick={onVerStockBajo} title="Ver y gestionar los productos agotados o por agotarse"
              style={{ backgroundColor: '#FEF3C7', border: '1px solid #F59E0B', color: '#92400E', borderRadius: '10px', padding: '8px 14px', fontWeight: 700, cursor: 'pointer' }}>
              ⚠️ Stock bajo{stockBajo > 0 ? ` (${stockBajo})` : ''}
            </button>
          )}
          {(ocultos.length > 0 || soloOcultos) && (
            <button onClick={() => setSoloOcultos((v) => !v)} title="Productos que tus clientas no ven en el catálogo en línea"
              style={{ backgroundColor: soloOcultos ? '#1F1A2E' : '#F3F4F6', border: '1px solid #D1D5DB', color: soloOcultos ? 'white' : '#374151', borderRadius: '10px', padding: '8px 14px', fontWeight: 700, cursor: 'pointer' }}>
              🙈 Ocultos del catálogo ({ocultos.length}){soloOcultos ? ' ✕' : ''}
            </button>
          )}
          {onVerDetalle && (
            <button onClick={onVerDetalle} title="Ver costo, ganancia y % por producto, e historial de movimientos" className="k-btn-ghost">
              📊 Detalle de inventario
            </button>
          )}
          <button onClick={onVerCategorias} className="k-btn-soft">
            🗂️ Categorías
          </button>
          <button onClick={onVolver} className="k-btn-soft">
            ← Volver
          </button>
        </div>
      </div>

      <input
        type="search"
        placeholder="🔍 Buscar por nombre, marca o código (o escanea con la lectora)"
        value={busqueda}
        onChange={(e) => onBuscar(e.target.value)}
        onKeyDown={manejarEnter}
        autoFocus
        className="k-input"
        style={{ marginBottom: '16px' }}
      />

      {cargando && (
        <div style={{ textAlign: 'center', padding: '48px', color: '#6B7280' }}>
          <div style={{ fontSize: '32px', marginBottom: '8px' }}>⏳</div>
          <p style={{ margin: 0, fontWeight: 600 }}>Cargando productos...</p>
        </div>
      )}

      {!cargando && error && (
        <div style={{ textAlign: 'center', padding: '32px', backgroundColor: '#FEE2E2', borderRadius: '12px', border: '1px solid #FCA5A5' }}>
          <p style={{ margin: '0 0 12px', color: '#991B1B', fontWeight: 600 }}>⚠️ {error}</p>
          <button onClick={onReintentar} style={{ backgroundColor: '#DC2626', color: 'white', border: 'none', borderRadius: '8px', padding: '8px 20px', fontWeight: 'bold', cursor: 'pointer' }}>
            Reintentar
          </button>
        </div>
      )}

      {!cargando && !error && lista.length === 0 && (
        <div style={{ textAlign: 'center', padding: '48px', color: '#6B7280' }}>
          <div style={{ fontSize: '32px', marginBottom: '8px' }}>🗃️</div>
          <p style={{ margin: 0 }}>
            {busqueda
              ? `Sin resultados para "${busqueda}".`
              : soloStockBajo
                ? '¡Ningún producto con stock bajo! 🎉'
                : `No hay productos ${categoriaSeleccionada ? 'en esta categoría' : 'todavía'}.`}
          </p>
        </div>
      )}

      {!cargando && !error && lista.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '16px' }}>
          {lista.map((p) => (
            <ProductoCard key={p.id} producto={p} onClick={() => onVerProducto(p)} onCompartir={setCompartir} />
          ))}
        </div>
      )}
      {compartir && <CompartirProductoModal producto={compartir} onCerrar={() => setCompartir(null)} />}
    </div>
  );
}
